import './App.css';
import PortfolioCard from './Components/PortfolioCard';
import Header from './Components/Header';
import Pageload from './Components/Pageload';
import {BrowserRouter as Router,Route} from "react-router-dom";

function App(props) {
  return (
    <div className="App">
      <Router>
          <Route
          strict
          exact
          component={PortfolioCard}
          path="/"
          history={props.history}>
          </Route>
          <Route
          strict
          exact
          component={Header}
          path="/header"
          history={props.history}>
          </Route>
          <Route
          strict
          exact
          component={Pageload}
          path="/pageload"
          history={props.history}>
          </Route>
        </Router>
    </div>
  );
}

export default App;
